import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './style.css';

const ContentSurface = ({ as: Component = 'div', children, className }) => {
  return (
    <Component className={clsx('content-surface', className)}>
      {children}
    </Component>
  );
};

ContentSurface.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ContentSurface;
